import { styled } from 'stitches.config'

export const ShippingRoot = styled('div', {
  backgroundColor: '$primary-100',
  color: '$primary-800',
  paddingTop: '$7',
  paddingBottom: '$10',
  px: '$3',

  '@bp2': {
    px: '$15',
  },
})

export const Content = styled('div', {
  maxWidth: '792px',
  margin: 'auto',
})
